export { Trash2 as default } from './Trash2';
